/** UI LAYER — selects the versioned, same-origin MapLibre module worker. */
import { getVersion, setWorkerUrl } from 'maplibre-gl'

setWorkerUrl(
  new URL(
    `/maplibre/${getVersion()}/maplibre-gl-worker.mjs`,
    window.location.origin
  ).href
)
